import {Box, Text} from '@mantine/core';
import type React from 'react';
import {COLOR_BAR_CHART} from '../../../../../config/constants/colorCodes';
import type {BarChartData} from './OfferedAttribute';

type Props = {
  data: BarChartData[];
};

export const BarChart: React.FC<Props> = ({data}) => {
  const maxCount =
    data.toSorted((a, b) => (b?.percent ?? 0) - (a?.percent ?? 0))[0]
      ?.percent ?? 0;

  return (
    <Box className="pc:px-8 mt-12">
      {data.map((d, index) => (
        <Box key={index} className="flex items-center h-24">
          <Box className="flex items-center justify-between flex-[6] text-base py-2 border-b-[1px] border-solid border-line-1 w-[160px] pc:w-auto">
            <Text className="max-w-[140px] pc:max-w-[300px] truncate whitespace-nowrap">
              {d.name}
            </Text>
            <Text className="font-bold">
              {d.percent?.toLocaleString() ?? '0'}
            </Text>
          </Box>
          <Box className="flex-[4] ml-28">
            <Box
              style={{
                height: 20,
                width: `${d.percent ? Math.floor((d.percent / maxCount) * 100) : 0}%`,
                backgroundColor: COLOR_BAR_CHART,
              }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};
